import React from 'react';
import Button from 'app/buttons';
import { FT_COLORS } from '../theme';

// Thin wrappers around the shared app Button so the feature matches the
// design palette (talking-family-tree-*.png) without touching the global theme.

export const PrimaryButton = ({ disabled, style, children, ...props }) => (
  <Button
    primary
    pill
    type="button"
    disabled={disabled}
    style={{
      ...(disabled
        ? {}
        : { background: FT_COLORS.primary, borderColor: FT_COLORS.primary, color: '#fff', fontFamily: 'Poppins', fontSize: '16px' }),
      ...style,
    }}
    {...props}
  >
    {children}
  </Button>
);

export const OutlineButton = ({ style, children, ...props }) => (
  <Button
    pill
    type="button"
    style={{ background: '#fff', border: `1px solid ${FT_COLORS.primary}`, fontFamily: 'Poppins', color: FT_COLORS.primary, fontSize: '16px', ...style }}
    {...props}
  >
    {children}
  </Button>
);

// Full-width lavender CTA — the "Create an invitation" empty state.
export const LavenderButton = ({ style, children, ...props }) => (
  <Button
    type="button"
    style={{
      background: FT_COLORS.surface,
      border: `1px dashed #9B59B6`,
      color: FT_COLORS.primary,
      borderRadius: '12px',
      width: '100%',
      justifyContent: 'space-between',
      height: '62px',
      ...style,
    }}
    {...props}
  >
    {children}
  </Button>
);
